import { useInfiniteQuery } from '@tanstack/react-query';
import { SearchState } from 'src/hooks/meilisearch/types/search-state';
import { useUserStore } from 'src/store/user-store';
import { ApiError } from 'src/types/interfaces/api-error';
import { MeiliSearchResponse } from 'src/types/responses/meilisearch';
import { getInfiniteQueryNextPageParam } from 'src/utils/get-infinite-query-next-page-param';
import { fetchTenantAvailableFloors } from '../lib/tenant';
import { tenantAvailableFloorsQueryKeys } from '../query-keys/tenant/tenant-available-floors';
import { TenantAvailableFloors } from '../types/response/tenant-available-floors.response';

export const useInfiniteTenantAvailableFloors = (
  perPage: number,
  enabled: boolean = true,
) => {
  const { directoryToken, meilisearchToken } = useUserStore();

  const searchState: SearchState = {
    filter: [],
    q: '',
    sort: [],
  };

  return useInfiniteQuery<MeiliSearchResponse<TenantAvailableFloors>, ApiError>(
    {
      queryKey: tenantAvailableFloorsQueryKeys.infiniteList(perPage),
      queryFn: ({ pageParam }) =>
        fetchTenantAvailableFloors(
          directoryToken!,
          searchState,
          Number(pageParam),
          perPage,
        ),
      initialPageParam: 1,
      getNextPageParam: getInfiniteQueryNextPageParam,
      enabled: enabled && !!meilisearchToken,
    },
  );
};
